<template>
  <div class="admin-notification-panel">
    <div class="panel-header">
      <div>
        <div class="text-h6">운영 알림</div>
        <div class="text-caption text-grey-7">
          실시간 운영 이벤트와 최근 알림 이력입니다.
        </div>
      </div>
      <q-btn flat round dense icon="close" @click="$emit('close')">
        <q-tooltip>닫기</q-tooltip>
      </q-btn>
    </div>

    <div class="panel-actions">
      <div class="summary-badges">
        <q-badge color="primary">미확인 {{ summary.unread }}</q-badge>
        <q-badge color="negative">오류 {{ summary.errors }}</q-badge>
        <q-badge color="warning">주의 {{ summary.warnings }}</q-badge>
        <q-badge color="grey-7">오늘 {{ summary.today }}</q-badge>
      </div>
      <div class="action-buttons">
        <q-btn
          flat
          round
          dense
          icon="done_all"
          color="primary"
          :disable="summary.unread === 0"
          @click="$emit('read-all')">
          <q-tooltip>전체 읽음 처리</q-tooltip>
        </q-btn>
        <q-btn
          flat
          round
          dense
          icon="refresh"
          color="primary"
          @click="$emit('refresh')">
          <q-tooltip>새로고침</q-tooltip>
        </q-btn>
      </div>
    </div>

    <div
      v-if="notifications.length === 0"
      class="notification-empty">
      최근 운영 알림이 없습니다.
    </div>

    <q-list v-else class="notification-list">
      <q-item
        v-for="row in notifications"
        :key="row.id"
        clickable
        class="notification-item"
        :class="{ 'notification-item--unread': !row.isRead }"
        @click="$emit('open-target', row)">
        <q-item-section avatar>
          <q-icon
            :name="notificationIcon(row.severity)"
            :color="notificationColor(row.severity)" />
        </q-item-section>
        <q-item-section>
          <q-item-label class="text-weight-medium">
            {{ row.title }}
          </q-item-label>
          <q-item-label caption>
            {{ row.caption || row.message || '-' }}
          </q-item-label>
          <q-item-label caption class="text-grey-6">
            {{ row.createdAt }} · {{ row.source || 'system' }}
          </q-item-label>
        </q-item-section>
        <q-item-section side>
          <q-btn
            flat
            dense
            round
            size="sm"
            icon="done"
            :disable="row.isRead"
            @click.stop="$emit('read', row)">
            <q-tooltip>읽음 처리</q-tooltip>
          </q-btn>
        </q-item-section>
      </q-item>
    </q-list>
  </div>
</template>

<script>
export default {
  name: 'AdminNotificationPanel',
  emits: ['close', 'refresh', 'read', 'read-all', 'open-target'],
  props: {
    notifications: {
      type: Array,
      default: () => []
    },
    summary: {
      type: Object,
      default: () => ({
        unread: 0,
        errors: 0,
        warnings: 0,
        today: 0
      })
    }
  },
  methods: {
    notificationIcon(severity) {
      const map = {
        error: 'error',
        warning: 'warning',
        success: 'check_circle',
        info: 'info'
      }
      return map[severity] || 'notifications'
    },

    notificationColor(severity) {
      const map = {
        error: 'negative',
        warning: 'warning',
        success: 'positive',
        info: 'primary'
      }
      return map[severity] || 'primary'
    }
  }
}
</script>

<style scoped>
.admin-notification-panel {
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 18px;
  background: #f8fafc;
}

.panel-header,
.panel-actions {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.panel-header {
  padding-bottom: 16px;
  border-bottom: 1px solid #e3e8ef;
}

.panel-actions {
  padding: 14px 0;
}

.summary-badges {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.action-buttons {
  flex-shrink: 0;
}

.notification-list {
  flex: 1;
  overflow-y: auto;
}

.notification-item {
  border: 1px solid #edf0f5;
  border-radius: 12px;
  margin-bottom: 10px;
  background: #fff;
}

.notification-item--unread {
  border-color: #b9d7ff;
  background: #f6faff;
}

.notification-empty {
  padding: 40px 16px;
  border: 1px dashed #cfd6e3;
  border-radius: 14px;
  color: #687386;
  text-align: center;
  background: #fff;
}
</style>
